import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoiceInputComponent } from './voice-input.component';
import { TooltipModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [VoiceInputComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  exports: [VoiceInputComponent],
  entryComponents: [VoiceInputComponent]
})
export class VoiceInputModule { }
